import { sidebarConstants as sc } from 'srcReact/components/common2/Navigation/SideBarMain/constant'

export const sidebarActions = {
  setCreatePostPopup
}

function setCreatePostPopup(value) {
  return { type: sc.CREATE_POST_POPUP, value }
}
